var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { useAnalytics } from "@travel/shared/data-access";
import { useRecentSearches } from "@travel/shared/hooks";
import { GlobalLogo } from "@travel/shared/global/ui";
import { useHotelAvailabilityURL, } from "@travel/hotel/shared/data-access";
import { createHotelListURL } from "@travel/hotel/shared/utils";
import { useLocationSearch } from "@travel/shared/locations/data-access";
import { HotelSearchForm } from "@travel/hotel/search/ui";
import styles from "./hotel-search-feature.module.css";
var TRACKING_BASE = "hotel:search:form";
export default function HotelSearchFeature(_a) {
    var _b;
    var _c;
    var _d = _a.locationQuery, locationQuery = _d === void 0 ? "" : _d, _e = _a.locationType, locationType = _e === void 0 ? "city" : _e, _f = _a.navigatePcln, navigatePcln = _f === void 0 ? true : _f, domain = _a.domain, logo = _a.logo, logoURL = _a.logoURL, companyName = _a.companyName, showLogo = _a.showLogo, _g = _a.showLogoPoweredBy, showLogoPoweredBy = _g === void 0 ? true : _g, displayCard = _a.displayCard, _h = _a.showTitle, showTitle = _h === void 0 ? true : _h, _j = _a.selectRecentLocation, selectRecentLocation = _j === void 0 ? false : _j, affiliate = _a.affiliate, campaign = _a.campaign, rest = __rest(_a, ["locationQuery", "locationType", "navigatePcln", "domain", "logo", "logoURL", "companyName", "showLogo", "showLogoPoweredBy", "displayCard", "showTitle", "selectRecentLocation", "affiliate", "campaign"]);
    var _k = __read(useState(), 2), availabilityRequest = _k[0], setAvailabilityRequest = _k[1];
    var _l = __read(useRecentSearches({
        type: "hotel",
    }), 2), recentSearches = _l[0], addRecentSearch = _l[1].add;
    var recent = useMemo(function () { return recentSearches.map(function (_a) {
        var location = _a.location;
        return location;
    }).slice(0, 5); }, [recentSearches]);
    var _m = useHotelAvailabilityURL(availabilityRequest), isLoadingAvailabilityURL = _m.isLoading, availabilityURL = _m.data, availabilityURLError = _m.error;
    var _o = useLocationSearch(locationQuery === null || locationQuery === void 0 ? void 0 : locationQuery.split(",")[0]), isLoadingSearchLocation = _o.isLoading, searchedLocations = _o.data;
    var foundLocationFromQuery = (_c = searchedLocations === null || searchedLocations === void 0 ? void 0 : searchedLocations.list) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
        var displayName = _a.displayName, type = _a.type;
        return displayName === locationQuery;
    });
    var _p = __read(useState(false), 2), willRedirect = _p[0], setWillRedirect = _p[1];
    var _q = __read(useState(false), 2), isSubmitted = _q[0], setIsSubmitted = _q[1];
    var track = useAnalytics().track;
    useEffect(function () {
        track("".concat(TRACKING_BASE, ":init"));
    }, []);
    useEffect(function () {
        if (!isSubmitted || !navigatePcln)
            return;
        if (availabilityURL) {
            setAvailabilityRequest(undefined);
            var redirect = function () {
                window.location.href = availabilityURL;
            };
            track("".concat(TRACKING_BASE, ":submit"), __assign(__assign({}, availabilityRequest), { availabilityURL: availabilityURL }))
                .then(redirect)
                .catch(redirect);
        }
        else {
            //@TODO: Throw an error of some sort?
            setWillRedirect(false);
        }
    }, [
        navigatePcln,
        isSubmitted,
        isLoadingAvailabilityURL,
        availabilityURL,
        track,
    ]);
    useEffect(function () {
        if (availabilityURLError) {
            setAvailabilityRequest(undefined);
        }
    }, [availabilityURLError]);
    return (_jsxs("div", { className: classNames(styles["container"], (_b = {},
            _b[styles["card"]] = displayCard,
            _b[styles["has-logo"]] = showLogo,
            _b)), children: [_jsxs("div", { className: styles["header"], children: [showLogo && logo ? (_jsx("a", { href: logoURL, className: styles["logo"], children: _jsx(GlobalLogo, { logo: logo, horizontal: "both", poweredBy: showLogoPoweredBy, size: "md", allowDarkMode: false }) })) : (showLogo && (_jsx("a", { href: logoURL, className: styles["logo"], children: _jsx("img", { src: "https://".concat(domain, "/assets/partners/ppn/logo.svg"), className: styles["img"], style: {
                                aspectRatio: "87 / 22",
                            } }) }))), showTitle && (_jsxs("div", { className: styles["title"], children: ["Save up to ", _jsx("strong", { children: "50% off" }), " Hotel Rates Worldwide"] }))] }), _jsx(HotelSearchForm, __assign({}, rest, { location: isLoadingSearchLocation || foundLocationFromQuery
                    ? foundLocationFromQuery
                    : selectRecentLocation
                        ? recent === null || recent === void 0 ? void 0 : recent[0]
                        : undefined, loadingLocation: isLoadingSearchLocation, recent: recent, searching: isSubmitted && (isLoadingAvailabilityURL || willRedirect), onChange: function (request) {
                    if (navigatePcln &&
                        request.location &&
                        request.location.type !== "geo" &&
                        request.checkIn &&
                        request.checkOut) {
                        setAvailabilityRequest(request);
                    }
                    setIsSubmitted(false);
                }, onLocationChange: function (location) {
                    if (location) {
                        track("".concat(TRACKING_BASE, ":selectLocation"), location);
                    }
                }, onSubmit: function (_a) {
                    var location = _a.location, dates = _a.dates, guestsAndRooms = _a.guestsAndRooms;
                    var request = {
                        location: location,
                        checkIn: dates.from,
                        checkOut: dates.to,
                        roomCount: guestsAndRooms.roomCount,
                        adultCount: guestsAndRooms.adultCount,
                    };
                    if (location.type !== "geo") {
                        addRecentSearch(location);
                    }
                    if (navigatePcln) {
                        setWillRedirect(true);
                        setAvailabilityRequest(request);
                    }
                    else {
                        var listURL = createHotelListURL(__assign(__assign({}, request), { campaign: affiliate, cid: campaign }));
                        var whiteLabelURL = "https://".concat(domain).concat(listURL);
                        track("".concat(TRACKING_BASE, ":submit"), __assign(__assign({}, request), { whiteLabelURL: whiteLabelURL, campaign: affiliate, cid: campaign }));
                        window.location.href = whiteLabelURL;
                    }
                    setIsSubmitted(true);
                } }))] }));
}
